import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GenericCrudService } from './generic-crud.service';
const API_URL = environment.prismaApiUrl +'/api/dispo/team_absence';

@Injectable({
    providedIn: 'root'
})
export class TeamAbsenceService extends GenericCrudService<Product>{

    constructor(http: HttpClient) {
        super(http, 'api/dispo/team_absence');
    }

    getAllByTeamBaseId(id: any): Observable<any> {
        return this.http.get(API_URL + '/get-all-by-id/' + id);
    }

}

export interface Product {
    id: number;
    name: string;
    price: number;
    // Weitere Eigenschaften deines Produkts
}

